'use client';

import { Box, Button, Heading, Flex, Stack } from '@chakra-ui/react';
import { useRouter } from 'next/navigation';

export function PageErrorMessage() {
  const { replace } = useRouter();

  return (
    <Flex minHeight="70vh" direction="column" justifyContent="center">
      <Stack pb={30} gap="2">
        <Heading textAlign="center" size="lg">
          Något gick fel
        </Heading>

        <Box textAlign="center" marginTop={4}>
          <Button
            variant="secondary"
            onClick={() => replace("/")}
          >
            Gå tillbaka
          </Button>
        </Box>
      </Stack>
    </Flex>
  );
};
